<div class="modal-dialog" [attr.role]="'document'">
	<div class="modal-content">
		<p class="col-sm-2 col-sm-offset-10 generic-close-modal-btn">
			<button class="btn btn-default-reverse btn-block btn-sm"
				[attr.data-dismiss]="'modal'" type="button" (click)="reset()">Chiudi</button>
		</p>
    <form>
		<div class="col-sm-12 coldx">
			<h4>Modifica dati</h4>
			<div
				assegnazione_competenza_form [attr.id]="assegnazioneCompetenzaForm" #assegnazioneCompetenzaForm (onSelectUser)="selectedUser = $event"
				[wizard]="wizard" [idFascicolo]="fascicoloId" (onSelectGroup)="gruppi = $event" [tipoFascicolo]="tipoFascicolo"
				[utenteCompetente]="selectedUser" (gruppiCompetentiOutput)="gruppiCompetenti = $event"></div>
		</div>
		<div class="row">
			<p class="col-sm-3 col-xs-6">
				<button type="button" class="btn btn-outline-secondary btn-block" (click)="reset()">Reset</button>
			</p>
			<p submitButton [disabled]="!selectedUser"
				class="col-sm-3 col-xs-6 col-sm-offset-6"
				(click)="update(selectedUser, gruppi)"
				[labelButton]="'Aggiorna e salva'"></p>
		</div>
  </form>
	</div>
</div>
